import { Stack, TableCell, TableRow } from "@mui/material";
import Warning from "assets/noDataWarning.png";
import { ReactComponent as Completed } from "assets/ProgressPillIcons/Completed.svg";
import { ReactComponent as InProgress } from "assets/ProgressPillIcons/InProgress.svg";
import { ReactComponent as New } from "assets/ProgressPillIcons/New.svg";
import { ReactComponent as Overdue } from "assets/ProgressPillIcons/Overdue.svg";
import { setShowExportLoader } from "components/common/Export/Export.slice";
import { fetchmembersInfo } from "components/common/Filters/Filters.slice";
import { setPageFilter } from "components/common/Filters/GlobalFilters.slice";
import { renewToken } from "components/common/HandleApiFailure";
import Typography from "components/common/Typography";
import {
  fetchSCListById,
  setCorpSearchText,
  setCorpViewSelectedTab,
  setEditListSuccess,
  setIsEditListModal,
  setNavigatedMyList,
  setSelectedListCategory
} from "components/features/Corp/CorpUser.Slice";
import { Hall } from "components/features/library/libraryHall/Hall";
import { getUserDetails } from "components/features/SME/sme.slice";
import _, { isEmpty, isFunction, uniq, uniqBy } from "lodash";
import moment from "moment";
import { useEffect } from "react";
import { store } from "redux/store";
import colors from "styles/Colors";
import { tokens } from "styles/Tokens";
import { axiosFileDownload, axiosPostFileDownload } from "./APIHelper";
import {
  ABOVE_PROPERTY,
  ABOVE_PROPERTY_DISPLAY_TYPE,
  ABOVE_PROP_USER_TYPE,
  ON_PROPERTY_DISPLAY_TYPE,
  PlanAssigmentLimit,
  brandDeadLine,
  corpUser,
  initiative,
  planSourceList,
  planTypes,
  sourceList
} from "./CommonConstants";
import { getResolvedUserDisplayName, getUserNameWithConditionalCheck } from "./SharedUtils";
import { responseTypes, tableExpandedValues, userTypes } from "./Types";

export const getHltInncodes = (isStringFormat = false) => {
  const { isImpersonated, userDetails }: any = store.getState().app.impersonationDetails;

  if (isImpersonated) {
    const inncodes = userDetails.innCodes;
    return isStringFormat ? inncodes?.join(",") : inncodes || [];
  }

  const inncodes = localStorage.getItem("hltInnCodes");
  return isStringFormat ? inncodes : inncodes?.split(",") ?? [];
};

export const getSharedInncodes = (inncodes: any) => {
  const { isCorp } = store.getState().app.loggedInUserDetails;
  return isCorp ? inncodes : inncodes?.filter((inncode: string) => getHltInncodes().indexOf(inncode) !== -1);
};

export const isBookmarked = (planId: any, innCodeToCompare?: string) => {
  const state: any = store.getState();
  const innCode = innCodeToCompare || state.app.innCode;
  const bookmarkedPlanList: any = state.bookmarkedPlans.list;
  const innCodeBookmark: any = bookmarkedPlanList?.find((item: any) => item.innCode === innCode);

  const bookmarkPlanIds = innCodeBookmark ? innCodeBookmark.cmsId : [];
  return planId && bookmarkPlanIds.includes(planId.toString());
};

export const getGlobalLevelFilterCount = (FilterCategories: any) => {
  let count: number = 0;
  if (
    FilterCategories?.key === "planSource" ||
    FilterCategories?.key === "planSources" ||
    FilterCategories?.key === "sources"
  ) {
    sourceList?.map((item: any) => {
      if (FilterCategories?.options?.includes(item.value[0])) count++;
    });
  } else count = FilterCategories?.options?.length;
  return count;
};

export const getMembersList = (searchValue: string, dispatch: any, inncode?: string) => {
  const props: any = {
    searchText: searchValue,
    page: 0,
    size: 100,
    ...(inncode && { innCode: inncode, includecorpusers: true })
  };
  dispatch(fetchmembersInfo(props));
};

export const getUserTypeValue = (isIncludeAboveProperty: boolean) => {
  return isIncludeAboveProperty ? "" : "HU";
};

export const shouldShowBanner = (rollOutDate: string) =>
  new Date() <= new Date(new Date(rollOutDate).setDate(new Date(rollOutDate).getDate() + 30));

export const setSelectedMyList = (dispatch: any, list: any, filterType: string) => {
  dispatch(setNavigatedMyList(list));
  dispatch(setSelectedListCategory(filterType));
  dispatch(setCorpViewSelectedTab({ type: "myList", val: 0 }));
  dispatch(setCorpSearchText({ view: "myList", value: "" }));
};

export const isAboveUserPlanBookmarked = (planId: any, planType: string) => {
  const state: any = store.getState();
  const bookmarkedPlanList: any = state.aboveProperty[planType];
  const attribute = planType === "bookmarkedIdList" ? "cmsId" : "templatePlanId";
  return bookmarkedPlanList?.find((item: any) => item[attribute] === planId);
};

export const functionalAreaIdToName = (id: string, functionalAreaList: Hall[], showAbbrv = false) => {
  const functionalAreaName = functionalAreaList?.find((el: any) => el.id === id);
  return showAbbrv ? functionalAreaName?.abbrv : functionalAreaName?.name;
};

export const functionalAreaNamesToIds = (functionalAreaNames: any) => {
  const state: any = store.getState();
  return functionalAreaNames.map(
    (item: any) =>
      state.functionalAreas.list.find((area: any) => {
        return item === area.name;
      }).id
  );
};

export const getCodesByNames = (names: string[], type: string, list: any[]) =>
  type !== "brand"
    ? names
    : Array.from(new Set(names?.map((n) => list?.find((i) => i?.brandName === n)?.brandCode).filter(Boolean)));

export const getBrandsCodesByName = (
  names: string[],
  brandCodes: { id: string | number; name: string }[],
  type: string
) => {
  const foundCodes =
    type === "brand" ? brandCodes.filter((item: any) => names.includes(item.name)).map((item: any) => item.id) : names;
  return foundCodes;
};

export const functionalAreaIdsToNames = (functionalAreaIds: any) => {
  const state: any = store.getState();
  return functionalAreaIds?.map(
    (item: any) =>
      state.functionalAreas.list.find((element: any) => {
        return item === element.id;
      })?.name
  );
};

export const getNamesByCodes = (codes: string[], list: any[]) =>
  Array.from(new Set(codes?.map((c) => list?.find((i) => i?.brandCode === c)?.brandName)?.filter(Boolean)));

export const getBrandOrRegion = (type: string, list: any[]) =>
  Array.from(
    new Map(
      (list || [])
        .filter((item) => (type === "brand" ? item?.brandCode && item?.brandName : item?.subRegion))
        .map((item) => {
          const id = type === "brand" ? item?.brandCode : item?.subRegion;
          const name = type === "brand" ? item?.brandName : item?.subRegion;
          const key = type === "brand" ? `${id}-${name}` : id;
          return [key, { id, name }];
        })
    ).values()
  );

export const sourceValuetoName = (sourceValue: any) => {
  return uniq(sourceValue?.map((item: any) => getSourceName(item))) as string[];
};

export const planTypeIdToName = (planTypeIds: any) => {
  return planTypeIds.map(
    (id: any) =>
      planTypes.find((type: any) => {
        return id === type.planTypeId;
      })?.planTypeName
  );
};

export const filterPayloadToPlanProgressPayload = (filterPayload: any) => {
  const { planSource, planStatus, ...payload } = filterPayload;
  return {
    ...payload,
    planSources: planSource?.join(","),
    status: planStatus?.join(","),
    planOwner: filterPayload["planOwner"]?.join(","),
    assignedBy: filterPayload["assignedBy"]?.join(","),
    overduePlan: filterPayload["overduePlan"]?.join(",")
  };
};

export const filterPayloadToPlanViewPlanProgressPayload = (filterPayload: any) => {
  const { brandCodes, regions, ...payload } = filterPayload;
  return {
    ...payload,
    brandCodes: brandCodes?.split(","),
    regions: regions?.split(",")
  };
};

export const getPlanDuration = (sections: any) => {
  let sumDurationPlan = 0;
  if (sections?.length > 0) {
    for (let section of sections) {
      sumDurationPlan = sumDurationPlan + getSectionDuration(section?.cards);
    }
  }
  const result = getHoursAndMin(sumDurationPlan);
  return result;
};

export const getSectionDuration = (Cards: any) => {
  let sumDurationSection = Cards?.reduce((initial: any, current: any) => {
    return initial + current?.timeEstimateMinutes;
  }, 0);
  return sumDurationSection || 0;
};

export const getHoursAndMin = (Sum: any) => {
  if (!Sum) return [0, 0];
  let sumHours = Math.floor(Sum / 60);
  let sumMinutes = Sum % 60;
  return [sumHours, sumMinutes];
};

export const converter_ArrayString = (data: any, key = "val") => {
  const dropArray = data?.map((el: any, index: any) => {
    return {
      id: el,
      [key]: el
    };
  });

  return dropArray;
};
export const converter_ArrayObj = (data: any, key: string) => {
  const dropArray = data?.map((el: any, index: any) => {
    return {
      id: el.id,
      val: el[key]
    };
  });

  return dropArray;
};

export const converter_inncode_ArrayObj = (data: any, key: string) => {
  const dropArray = data?.map((el: any, index: any) => {
    return {
      id: el.innCode,
      name: el[key]
    };
  });

  return dropArray;
};

export const reorder = (list: any, startIndex: number, endIndex: number) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

export const getInitials = (user: any) => {
  const firstTwoChars = (str?: string) => `${str?.charAt(0) ?? ""}${str?.charAt(1) ?? ""}`.toUpperCase();

  if (user?.displayName) return firstTwoChars(user.displayName);
  if (user?.firstName && user?.lastName) return `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`.toUpperCase();
  if (user?.firstName) return firstTwoChars(user.firstName);
  if (user?.lastName) return firstTwoChars(user.lastName);
  if (user?.email) return firstTwoChars(user.email);
  return firstTwoChars(user?.hltId);
};

export const valueIsEmpty = (value: any) => {
  const type = typeof value;
  if ((value !== null && type === "object") || type === "function") {
    const props: any = Object.keys(value);
    if (props.length === 0 || props.size === 0) {
      return true;
    }
  }
  return !value;
};

export const useDebouncedEffect = (effect: any, deps: any, delay: number) => {
  useEffect(() => {
    const handler = setTimeout(() => effect(), delay);
    return () => clearTimeout(handler);
  }, [...(deps || []), delay]);
};

export const encrypt = (salt: any, text: any) => {
  const textToChars = (text: any) => text.split("").map((c: any) => c.charCodeAt(0));
  const byteHex = (n: any) => Number(n).toString(16).substring(-2);
  const applySaltToChar = (code: any) => textToChars(salt).reduce((a: any, b: any) => a ^ b, code);

  return text.split("").map(textToChars).map(applySaltToChar).map(byteHex).join("");
};

export const decrypt = (salt: any, encoded: any) => {
  const textToChars = (text: any) => text.split("").map((c: any) => c.charCodeAt(0));
  const applySaltToChar = (code: any) => textToChars(salt).reduce((a: any, b: any) => a ^ b, code);
  return encoded
    ?.match(/.{1,2}/g)
    .map((hex: any) => parseInt(hex, 16))
    .map(applySaltToChar)
    .map((charCode: any) => String.fromCharCode(charCode))
    .join("");
};

export const createParamforSearch = (isCorp: boolean, planInncode: string) => {
  if (isCorp) return [planInncode];
  else return uniq([...(getHltInncodes() || []), planInncode]);
};

export const getFilteredAssignees = (assignee: any, allAssignees: any) => {
  return uniqBy(allAssignees, (element: any) => element.hltId).filter((currAssignee: any) =>
    assignee?.includes(currAssignee.hltId)
  );
};

export const getAssigneesIncludingUnresolved = (assignee: any, allAssignees: any) => {
  const resolved = getFilteredAssignees(assignee, allAssignees);
  const state: any = store.getState();
  if (!state.app.loggedInUserDetails?.isAbovePropertyUser) return resolved;
  const resolvedIds = resolved.map((item: any) => item.hltId);
  const unresolved = (assignee || [])
    .filter((hltId: string) => !resolvedIds.includes(hltId))
    .map((hltId: string) => ({ hltId }));
  return [...resolved, ...unresolved];
};

export const onDownloadClick = (url: string, service: string, setNoAccess?: any) => {
  axiosFileDownload(url, service)
    .then((response: any) => {
      const filename = response.headers.get("content-disposition").split('"')[1];
      let url = window.URL.createObjectURL(new Blob([response.data]));
      let a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.click();
    })
    .catch((err) => {
      console.log(err, err);
      setNoAccess(true);
    });
};

export const fileExportHandler = async (url: string, service: string, data: any, isGet: boolean = false) => {
  const downloadMethod = isGet ? axiosFileDownload : axiosPostFileDownload;
  store.dispatch(setShowExportLoader(true));
  const response: any = await renewToken(); // renew the token before hitting export endpoint
  const { access_token, refresh_token } = response.data;
  if (access_token) localStorage.setItem("id_token", access_token);
  if (refresh_token) localStorage.setItem("refresh_token", refresh_token);

  downloadMethod(url, service, data)
    .then((response: any) => {
      const filename = response.headers.get("content-disposition").split('"')[1];
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const element = document.createElement("a");
      element.href = url;
      element.download = filename;
      element.click();
    })
    .finally(() => {
      store.dispatch(setShowExportLoader(false));
    });
};

export const refreshToken = async () => {
  const response: any = await renewToken(); // renew the token before hitting export endpoint
  const { access_token, refresh_token } = response.data;
  if (access_token) localStorage.setItem("id_token", access_token);
  if (refresh_token) localStorage.setItem("refresh_token", refresh_token);
};

export const getUserTypeTag = (lobbyUserType: string) => {
  return String(lobbyUserType).toLowerCase() === ABOVE_PROP_USER_TYPE
    ? ABOVE_PROPERTY_DISPLAY_TYPE
    : ON_PROPERTY_DISPLAY_TYPE;
};

export const getIsCorpUser = (lobbyUserType: string) => {
  return corpUser.includes(String(lobbyUserType).toLowerCase());
};

export const getLoggedInUserDetails = (skipImpersonate: any = false) => {
  const state: any = store.getState();
  const { isImpersonated, userDetails } = state.app.impersonationDetails;
  return isImpersonated && !skipImpersonate ? userDetails : state.app.userName;
};

export const getLoggedInUserHltId = () => {
  return localStorage.getItem("hltId");
};

export const getUserHltId = () => {
  const state: any = store.getState();
  const { isImpersonated, userDetails } = state.app.impersonationDetails;
  return isImpersonated ? userDetails.hltId : getLoggedInUserHltId();
};

export const getUserType = () => {
  const state: any = store.getState();
  const { isImpersonated, userDetails } = state.app.impersonationDetails;
  const userName = state.app.userName;

  switch (String(isImpersonated ? userDetails.lobbyUserType : userName.lobbyUserType).toLowerCase()) {
    case "cc":
    case "ce":
      return userTypes.CORPORATE;

    case "ow":
      return userTypes.ABOVE_PROPERTY;

    default:
      return userTypes.HOTEL_USER;
  }
};

export const matchOwnerWithHltId = (ownerList: string) => {
  const hltId = getUserHltId();
  if (hltId && ownerList?.indexOf(hltId) > -1) return true;
  return false;
};

export const getOwnersList = () => {
  const state: any = store.getState();
  const owners = state.myPlanDetails.owner;
  if (!owners?.length) return "";
  return owners.map((item: any) => getResolvedUserDisplayName(item) || item?.hltId).join(", ");
};

export const isPlanMember = (hltId: string) => {
  const state: any = store.getState();
  const { owners = [], members = [] } = state.myPlanDetails.myPlanDetails;
  return [...owners, ...members]?.find((item: any) => item === hltId)?.length;
};

export const matchPlanType = (planType?: string, PlanDetail?: string) => {
  if (planType && (planType === brandDeadLine || initiative)) {
    return true;
  } else {
    return false;
  }
};

export const getPlantypeName = (planType?: number) => {
  if (planType === 1) {
    return brandDeadLine;
  } else if (planType === 2) {
    return initiative;
  } else {
    return null;
  }
};

export const getPlanDetail = (planId: any, list: any) => {
  const plan = list?.find((el: any) => el.cmsId == planId);
  return plan;
};

export const filterData = (criteria: any, data: any) => {
  return data.filter((obj: any) => {
    return Object.keys(criteria).every((key: any) => {
      return (
        (Array.isArray(criteria[key]) &&
          criteria[key].some((c: any) => {
            return typeof obj[key] === "string" && obj[key].indexOf(c) > -1;
          })) ||
        criteria[key].length === 0
      );
    });
  });
};
export const getChipDetails = (totalCards: 0, completedCards: 0, cardList?: []) => {
  const isOverdue = cardList?.some(
    (item: any) =>
      moment(item?.dueDate).isBefore(moment(new Date()).format("YYYY-MM-DD")) && item?.status !== "Completed"
  );

  let icon = <New />,
    color = tokens.Text.Feedback.Neutral,
    backgroundColor = tokens.Background.Feedback.Info;

  switch (true) {
    case isOverdue: {
      icon = <Overdue />;
      color = tokens.Text.Feedback.OverdueDark;
      backgroundColor = tokens.Background.Feedback.Overdue;
      break;
    }
    case completedCards < totalCards && cardList?.some((item: any) => item?.status === "Completed"): {
      icon = <InProgress />;
      color = tokens.Text.Feedback.ProgressDark;
      backgroundColor = colors.Cyan.Cyan100;
      break;
    }
    case completedCards === totalCards && completedCards > 0: {
      icon = <Completed />;
      color = tokens.Text.Feedback.SuccessDark;
      backgroundColor = tokens.Background.Feedback.SuccessDark;
      break;
    }
  }

  return {
    icon,
    color,
    backgroundColor,
    label: `${completedCards ?? 0}/${totalCards ?? 0} Actions Completed`
  };
};

export const getListOfFilters = () => {
  const state: any = store.getState();
  const {
    selectedFunctionalAreas,
    selectedInncodes,
    selectedBrand,
    selectedStatus,
    selectedPlanType,
    filterIds,
    selectedUser
  } = state.app;

  const selectedAdminInncodes = state.myplans.MyPlans.selectedAdminInncodes;

  const filtersArray = [
    selectedFunctionalAreas,
    selectedInncodes,
    selectedBrand,
    selectedStatus,
    selectedPlanType,
    filterIds,
    selectedAdminInncodes,
    selectedUser
  ];
  const filteredData = filtersArray?.filter((element) => element?.length > 0);

  return filteredData;
};

export const userNameToHltId = (userNames: any, state: any, hltKey?: string) => {
  return userNames.map(
    (item: any) =>
      state.find((op: any) => {
        return item === op.displayName;
      })[hltKey ?? "hltId"]
  );
};

export const getOwnerNames = (hltIds: string[]) => {
  const state: any = store.getState();
  const response = state.aboveProperty?.roleCategoryList?.filter((ele: any) => {
    return hltIds?.find((element: any) => ele.hltId === element);
  });
  const ownerNames = response?.map((el: any) =>
    getUserNameWithConditionalCheck(el?.displayName, el?.firstName, el?.lastName)
  );
  return ownerNames;
};

export const getPropertyName = (inncode: string) => {
  const state: any = store.getState();
  return state.aboveProperty.propertyList.find((element: any) => element.innCode === inncode)?.propName;
};
export const getPropertyInncode = (propertyNames: string[]) => {
  const state: any = store.getState();
  const response = state.aboveProperty.propertyList.filter((element: any) => {
    return propertyNames?.find((ele: any) => ele === element.propName);
  });
  const propertyInncodes = response?.map((el: any) => el?.innCode);

  return propertyInncodes;
};
export const getPropertyNames = (inncodes: string[]) => {
  const propertyNames = inncodes?.map((el: any) => getPropertyName(el));
  return propertyNames;
};

export const getMoreValues = (list: any) => {
  if (!list?.length) return "-";
  return list?.length > 1 ? `${list[0]}, (+${list.length - 1})` : `${list[0]}`;
};

export const mapUserListToTooltip = (userList: any) => {
  return userList?.map((user: string) => {
    return { name: user };
  });
};

export const getSourceName = (source: string) => {
  return source in planSourceList ? planSourceList[source] : "-";
};

export const getKeyByValue = (object: any, value: any) => {
  return Object.keys(object).filter((key) => object[key] === value);
};

export const getPlanSourceId = (sources: string[]) => {
  return sources.map((s: any) => Object.keys(planSourceList).filter((k: any) => planSourceList[k] === s));
};

export const getBrandCodesForAboveProperties = (brandNames = [], allProperties: any) => {
  return brandNames.map(
    (item: any) =>
      allProperties.find((a: any) => {
        return item === a.brandName;
      })?.brandCode
  );
};

export const checkUserAccess = (type: string) => {
  if (!type) return true;
  const permissionTypes = ["View", "Edit", "Delete", "Assign"];
  const state: any = store.getState();
  const { isCorp, permission, isLeadership, isAbovePropertyUser } = state.app.loggedInUserDetails;
  const isImpersonated = state.app.impersonationDetails?.isImpersonated;
  const selectedMyPlanDetail = state.myPlanDetails.myPlanDetails;

  //Do not check permissions for template plans.
  const params = new URLSearchParams(window.location.search);
  const isTemplatePlan = selectedMyPlanDetail.innCode === ABOVE_PROPERTY;
  const isTemplateParentTab = params.get("parentTab") === "Template Plans";
  const isActionPlanParentTab =
    (params.get("parentTab") === "Action Plan" &&
      (isTemplatePlan || window.location.pathname.split("/")[1] === "plandetails")) ||
    params.get("tab") === "Individual Actions" ||
    params.get("parentTab") === "Individual Actions"; //copy section/action & save as template plan.

  if (
    getUserType() === userTypes.HOTEL_USER &&
    !isLeadership &&
    window.location.pathname.split("/")[1] === "myplandetails" &&
    !isPlanMember(getUserHltId())
  )
    return false;
  if ((isTemplateParentTab || isTemplatePlan || isActionPlanParentTab) && !isImpersonated) return true;

  if (isCorp || isImpersonated) return permissionTypes.indexOf(type) <= permissionTypes.indexOf(permission);
  if (
    (!isAbovePropertyUser && !isCorp && !isLeadership && window.location.pathname.split("/")[1] === "myplandetails") ||
    window.location.pathname.split("/")[1] === "inncodeplandetails" ||
    window.location.pathname.split("/")[1] === "templateplandetails"
  ) {
    return !!isPlanMember(getUserHltId());
  }
  return true;
};

export const addDynamicId = (data: any) => {
  const newData = data.map((innCode: any, index: number) => {
    innCode.id = index;
    return innCode;
  });
  return newData;
};
export const getKeyMetricsPropertiesData = (overview: any) => {
  return [
    {
      isPrimary: true,
      subTitle: "Total Properties",
      data: overview?.totalPropertiesCount
    },
    { subTitle: "Active", data: overview?.activePropertiesCount, showBorder: true },
    {
      subTitle: "*Adding Plans",
      data: overview?.addingPlanPropertiesCount,
      showBorder: true
    },
    {
      subTitle: "*Completing Plans",
      data: overview?.completingPlansPropertiesCount,
      showBorder: true
    },
    {
      subTitle: "With Overdue Plans",
      data: overview?.withOverDuePlansPropertiesCount
    }
  ];
};

export const getKeyMetricsPropertiesDataForSc = (overview: any) => {
  return [
    {
      isPrimary: true,
      subTitle: "Total Properties",
      data: overview?.totalPropertiesCount
    },
    { subTitle: "*Plans Assigned", data: overview?.assignedCmsPlansCount, showBorder: true },
    {
      subTitle: "*High Engagement",
      data: overview?.highEngagementPropertiesCount,
      showBorder: true
    },
    {
      subTitle: "*Medium Engagement",
      data: overview?.mediumEngagementPropertiesCount,
      showBorder: true
    },
    {
      subTitle: "*Low Engagement",
      data: overview?.lowEngagementPropertiesCount
    }
  ];
};

export const getKeyMetricsPlansData = (overview: any) => {
  return [
    {
      isPrimary: true,
      subTitle: "*Total Plans",
      data: overview.totalMyPlans
    },
    { subTitle: "Active", data: overview.activeMyPlans, showBorder: true },
    {
      subTitle: "New",
      data: overview.newMyPlans,
      showBorder: true
    },
    {
      subTitle: "Overdue",
      data: overview.overdueMyPlans,
      showBorder: true
    },
    {
      subTitle: "*Completed",
      data: overview.completedMyPlans
    }
  ];
};

export const getKeyMetricsPlansDataSC = (overview: any) => {
  return [
    {
      isPrimary: true,
      subTitle: "Inncodes",
      data: overview.totalPropertiesCount
    },
    { subTitle: "Plan Assignments", data: overview.planAssignmentsCount, showBorder: true },
    {
      subTitle: "Plan w/ overdues Actions",
      data: overview.plansWithOverdueCardsCount,
      showBorder: true
    },
    {
      subTitle: "Plan w/ unassigned Actions",
      data: overview.plansWithUnassignedCardsCount,
      showBorder: false
    }
  ];
};

export const getTableColor = (val: string) => {
  if (val) {
    const newVal = val.replace(/\s/g, "").toLowerCase();
    return tableExpandedValues[newVal];
  }
  return tokens.Text.General.PrimaryBody;
};

/* Filtered out the entries with a count not equal to zero
Converted the object into an array of key-value pairs to use in the common table*/
export const getplanSourceCount = (list: any) => {
  if (list) {
    let counts: { [key: string]: number } = {};
    let sourceListData = sourceList;
    for (const key in list) {
      if (key in list) {
        const count = list[key];
        for (const item of sourceListData) {
          if (item.value.includes(key)) {
            counts[item.name] = (counts[item.name] || 0) + count;
            break;
          }
        }
      }
    }

    const array_List = Object.entries(counts)
      .filter(([_, count]) => count > 0)
      .map(([name, value]) => ({ name, value }));
    return array_List;
  }
  return null;
};

const extractHltIds = (dataArray: any): string[] => {
  return dataArray
    ?.filter((item: any) => item.hasOwnProperty("hltIds"))
    ?.flatMap((item: any) => (Array.isArray(item?.hltIds) ? item?.hltIds : [String(item?.hltIds)]));
};

const transformData = (dataArray: any) => {
  return dataArray.reduce((acc: any, item: any) => {
    if (item.hltId) {
      acc[item.hltId] = item;
    }
    return acc;
  }, {});
};

const dataFormationForScUser = async (val: any) => {
  const response = await store.dispatch(
    fetchSCListById({
      id: val.id,
      view: "inncodes",
      engagement: "",
      innCode: "",
      size: PlanAssigmentLimit
    })
  );
  const payload: any = response?.payload;
  if (payload?.status === responseTypes.success) {
    const mappings = payload.mappings;
    const hltIds = extractHltIds(mappings);
    let res;
    if (hltIds?.length) res = await store.dispatch(getUserDetails(hltIds));
    const userList = res?.payload?.users ? transformData(res?.payload?.users) : [];
    payload.description = val.description;
    payload.isFlagged = val.isFlagged;
    store.dispatch(setEditListSuccess({ userList, listData: payload, type: "sc" }));
    store.dispatch(setIsEditListModal(true));
  }
};

export const editList = async (val: any, type: string) => {
  if (type === "sc") {
    dataFormationForScUser(val);
  } else {
    store.dispatch(setEditListSuccess({ userList: null, listData: val, type: "static" }));
    store.dispatch(setIsEditListModal(true));
  }
};
export const getNamesFromHtlId = (hltIds: string[], dataList: any) => {
  const response = dataList?.filter((ele: any) => {
    return hltIds?.find((element: any) => ele.hltId === element);
  });
  const names = response?.map((el: any) =>
    getUserNameWithConditionalCheck(el?.displayName, el?.firstName, el?.lastName)
  );
  return names;
};

export const findDisplayNameById = (id: string, users: any) => {
  const user = users?.find((user: any) => user.hltId === id);
  return user ? getUserNameWithConditionalCheck(user?.displayName, user?.firstName, user?.lastName) : "";
};

export const setExtractMemberList = (memberList: any) => {
  let member: string[] = [];
  if (memberList && memberList.length) {
    memberList.map((user: any) => {
      if (user.inncodeusers) {
        member = [...user.inncodeusers, ...member];
      }
    });
  }
  return _.uniq(member);
};

export const getUserNameByHltId = (allUsers: any, userInfo: any) => {
  const user = allUsers?.find((user: any) => user.hltId === userInfo);
  return user;
};

export const getAllMapedIdAndUsers = (mappings: any) => {
  const mappingId: number[] = [];
  const hltId: string[] = [];
  mappings.map((mapped: any) => {
    mappingId.push(mapped.mappingId);
    hltId.push(mapped.hltId);
  });
  return { mappingId, hltId };
};

export const convertYNToStatus = (val: string) => {
  let value = val.toLowerCase();
  return value === "y" ? "Enabled" : "Disabled";
};

export const convertBooleanToStatus = (value: string) => {
  return value ? "Enabled" : "Disabled";
};

export const convertArrayToString = (obj: any) => {
  let newObj: any = {};
  for (let key in obj) {
    if (Array.isArray(obj[key])) {
      newObj[key] = obj[key].map((item: string) => item.trim()).join(",");
    } else {
      newObj[key] = obj[key];
    }
  }

  return newObj;
};

export const getDateColor = (date: any, status: string) => {
  const todaysDate = moment().format("YYYY-MM-DD");
  return moment(date).isBefore(todaysDate) && status !== "completed"
    ? tokens.Text.Feedback.Alert
    : tokens.Text.General.PrimaryHeadline;
};

export const detectBrowser = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.includes("chrome") && !userAgent.includes("edge")) {
    return "Google Chrome";
  } else if (userAgent.includes("firefox")) {
    return "Mozilla Firefox";
  } else if (userAgent.includes("safari") && !userAgent.includes("chrome")) {
    return "Safari";
  } else if (userAgent.includes("edge") || userAgent.includes("edg")) {
    return "Microsoft Edge";
  } else if (userAgent.includes("opera") || userAgent.includes("opr")) {
    return "Opera";
  } else {
    return "Unknown Browser";
  }
};

export const detectOS = () => {
  const platform = navigator.platform.toLowerCase();
  const userAgent = navigator.userAgent.toLowerCase();

  if (platform.includes("mac")) {
    return "macOS";
  } else if (platform.includes("win")) {
    return "Windows";
  } else if (platform.includes("linux")) {
    return "Linux";
  } else if (/android/.test(userAgent)) {
    return "Android";
  } else if (/iphone|ipad|ipod/.test(userAgent)) {
    return "iOS";
  } else {
    return "Unknown OS";
  }
};

export const changePendoByAction = (inn: any) => {
  if (window.pendo) {
    window.pendo.updateOptions({
      account: {
        id: inn
      }
    });
  }
};

export const formFilterRequestPayload = (appliedFilter: any[], functionForResultManipulation?: any) => {
  if (isEmpty(appliedFilter)) return [];
  let requestObj: any = {};
  appliedFilter.forEach((item, index) => {
    if (item?.key === "createdDate") {
      const [f, t] = item?.options?.[0]?.split(" To ") || [];
      const iso = (d?: string) => {
        if (!d) return;
        const [dd, mon, yy] = d.split(" ");
        return `${yy}-${String(new Date(`${mon} 1`).getMonth() + 1).padStart(2, "0")}-${dd}`;
      };
      requestObj.createdDateFrom = iso(f);
      requestObj.createdDateTo = iso(t || f);
    } else requestObj[item?.key] = item?.options;
  });
  return isFunction(functionForResultManipulation) ? functionForResultManipulation(requestObj) : requestObj;
};

export const convertArrayValuesToString = (obj: any) => {
  const result: Record<string, any> = {};

  for (const key in obj) {
    if (Array.isArray(obj[key])) {
      // Convert array to a comma-separated string
      result[key] = obj[key].join(",");
    } else {
      // Otherwise, keep the value as is
      result[key] = obj[key];
    }
  }

  return result;
};

export const noDataFound = (length: any, noDataMessage: any) => {
  return (
    <TableRow>
      <TableCell colSpan={length}>
        <Stack spacing={3} alignItems="center" justifyContent="center" sx={{ padding: "40px 24px" }}>
          <img src={Warning} alt="No Data Warning" className="no-data-banner-icon" />
          <Typography variant="body1" color={tokens.Text.General.Tertiary}>
            {noDataMessage}
          </Typography>
        </Stack>
      </TableCell>
    </TableRow>
  );
};

export const copyCreatedDateFilterPayload = (filterRequestPayload: any, dispatch: any, pageName: string) => {
  const createdDateObj = filterRequestPayload?.find((item: any) => item?.key === "createdDate");
  if (createdDateObj)
    dispatch(
      setPageFilter({
        pageName: pageName,
        modifiedFilter: [createdDateObj]
      })
    );
};

export const formatToDisplayRange = ({
  createdDateFrom,
  createdDateTo
}: {
  createdDateFrom: string;
  createdDateTo: string;
}) => {
  const fmt = new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric"
  });

  const from = fmt.format(new Date(createdDateFrom));
  const to = fmt.format(new Date(createdDateTo));

  return `${from} To ${to}`;
};

export const setUserAssociatedInncodes = (inncodes = []) => {
  localStorage.setItem("associatedInncodes", JSON.stringify(inncodes));
};

export const getUserAssociatedInncodes = () => {
  const associatedInncodes = localStorage.getItem("associatedInncodes");
  if (!associatedInncodes) return [];
  return JSON.parse(associatedInncodes);
};

export const checkIsPlanCustomizedOrNot = (beFlag: boolean) => {
  return beFlag ? "Yes" : "No";
};
